import { render, staticRenderFns } from "./VxProgress.vue?vue&type=template&id=4940f81e&scoped=true&lang=html"
import script from "./VxProgress.vue?vue&type=script&lang=js"
export * from "./VxProgress.vue?vue&type=script&lang=js"
import style0 from "./VxProgress.vue?vue&type=style&index=0&id=4940f81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940f81e",
  null
  
)

export default component.exports